// Djayma Admin — lightweight entry point (no storefront analytics)

// Sentry DSN warning — must be set in production for error tracking
if (!import.meta.env.VITE_SENTRY_DSN) {
  console.warn(
    '[Sentry] VITE_SENTRY_DSN not set — errors will NOT be tracked in production. See docs/runbooks/sentry-setup.md',
  );
}

import "@/i18n";

import { createRoot } from "react-dom/client";
import App from "./App";
import "@/index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Register service worker for PWA / offline support
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // SW registration failed — app continues without offline support
    });
  });
}
